export const track = (data: { eventName: string; eventData: Record<string, any> }) => {
  (window as any)?.dataLayer.push({
    event: 'track',
    sendToHeap: true,
    ...data,
  });
};
